import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Blog1 from "../../../../assets/images/blog1.png";
import Blog2 from "../../../../assets/images/blog2.png";


const SliderComponent: React.FC<any> = () => {
    const settings = {
        slidesToShow: 2,
        autoplay: false,
        autoplaySpeed: 2000,
        dots: true,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: false,
        centerMode: false,
        vertical: false,
        infinite: true,
        adaptiveHeight: false,
        lazyIndicator: "/arquivos/ajax-loader.gif",

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                },
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    };
    return (
        <div className="blogSlider">
            <Slider {...settings}>
                <div className="blogWrap">
                  <img src={Blog1} alt="blog image"/>
                </div>
                <div className="blogWrap">
                  <img src={Blog2} alt="blog image"/>
                </div>
                <div className="blogWrap">
                  <img src={Blog2} alt="blog image"/>
                </div>
            </Slider>
        </div>
    )
};

export default SliderComponent;
